import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useLocation } from 'react-router-dom';
import { IMyOwnTractorDetail } from '../../../../interfaces/OwnTractor.interfaces';
import { getMyOwnTractorById, myOwnTractorsApiUrl } from '../../../../api/user/queries/getMyOwnTractorById';

interface IUseGetMyOwnTractorByIdQueryParams {
  ownTractorId: string;
}

export const useGetMyOwnTractorById = ({ ownTractorId }: IUseGetMyOwnTractorByIdQueryParams) => {
  const location = useLocation();

  return useQuery<IMyOwnTractorDetail, AxiosError>(
    [`${myOwnTractorsApiUrl}_by_id`, ownTractorId],
    () => getMyOwnTractorById({ ownTractorId }),
    {
      enabled: Boolean(ownTractorId),
    },
  );
};
